"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentReceiptResponseDataDtoListingStatusEnum = void 0;
exports.instanceOfPaymentReceiptResponseDataDto = instanceOfPaymentReceiptResponseDataDto;
exports.PaymentReceiptResponseDataDtoFromJSON = PaymentReceiptResponseDataDtoFromJSON;
exports.PaymentReceiptResponseDataDtoFromJSONTyped = PaymentReceiptResponseDataDtoFromJSONTyped;
exports.PaymentReceiptResponseDataDtoToJSON = PaymentReceiptResponseDataDtoToJSON;
exports.PaymentReceiptResponseDataDtoToJSONTyped = PaymentReceiptResponseDataDtoToJSONTyped;
/**
 * @export
 */
exports.PaymentReceiptResponseDataDtoListingStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    UnderOffer: 'under_offer',
    OffTheMarket: 'off_the_market',
    PassedIn: 'passed_in',
    Disabled: 'disabled',
    Deleted: 'deleted',
    Sold: 'sold'
};
/**
 * Check if a given object implements the PaymentReceiptResponseDataDto interface.
 */
function instanceOfPaymentReceiptResponseDataDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('receiptUrl' in value) || value['receiptUrl'] === undefined)
        return false;
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    if (!('listingStatus' in value) || value['listingStatus'] === undefined)
        return false;
    return true;
}
function PaymentReceiptResponseDataDtoFromJSON(json) {
    return PaymentReceiptResponseDataDtoFromJSONTyped(json, false);
}
function PaymentReceiptResponseDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'receiptUrl': json['receiptUrl'],
        'amount': json['amount'],
        'listingStatus': json['listingStatus'],
    };
}
function PaymentReceiptResponseDataDtoToJSON(json) {
    return PaymentReceiptResponseDataDtoToJSONTyped(json, false);
}
function PaymentReceiptResponseDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'receiptUrl': value['receiptUrl'],
        'amount': value['amount'],
        'listingStatus': value['listingStatus'],
    };
}
